import Header from "./Header";
export default function Feedback({ event }) {
  return (
    <>
      <Header />
      <div className="bg-gradient-to-b from-[#dceaf5] to-white">
        <section>
          <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8">
            {/* <header className="text-center">
            </header> */}
            <div key={event.id} className="mb-4 mt-8 flex justify-center">
              <img
                src={event.feedback_form}
                alt="QR Code FOR Feedback Form"
                className="w-full md:w-3/4 lg:w-1/2"
              />
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
